import { AdminCollectionEditor } from '../../_Shared/_UI/AdminCollectionEditor';
import { AdminViewLayout } from '../../_Shared/_UI/AdminViewLayout';
import { ADMIN_DEFAULT_ORDER, ADMIN_VISIBILITY_FILTER } from '../../_Shared/_Config/AdminCollectionFilters';
import { EXPERIENCE_ADMIN_API as API } from '../_MODULES/_API';
import '../../_Shared/_UI/_Styles/PortfolioAdmin.css';

const EXPERIENCE_FILTERS = [
    ADMIN_VISIBILITY_FILTER,
    {
        key: 'company_filter',
        field: 'company',
        label: 'Empresa / proyecto',
        type: 'multi',
        placeholder: 'Seleccionar empresas…',
    },
];

export const ExperienceViewMain = () => (
    <AdminViewLayout
        pageKey="experience"
        title="Trayectoria"
        description="Administra puestos, empresas, periodos y responsabilidades de tu linea de tiempo profesional."
    >
        <AdminCollectionEditor
            title="Experiencia profesional"
            listEndpoint={API.LIST}
            saveEndpoint={API.SAVE}
            removeEndpoint={API.REMOVE}
            titleField="role"
            subtitleField="company"
            searchFields={['period', 'start_date', 'end_date', 'role', 'company', 'description']}
            filters={EXPERIENCE_FILTERS}
            orderOptions={ADMIN_DEFAULT_ORDER('role')}
            fields={[
                { name: 'role', label: 'Puesto / rol' },
                { name: 'company', label: 'Empresa / proyecto' },
                { name: 'start_date', label: 'Fecha de inicio', type: 'date' },
                {
                    name: 'completed',
                    label: 'Finalicé esta experiencia',
                    type: 'checkbox',
                    defaultValue: false,
                    clearFieldsWhenFalse: ['end_date'],
                },
                {
                    name: 'end_date',
                    label: 'Fecha de finalización',
                    type: 'date',
                    required: true,
                    visibleWhen: (values) => !!values.completed,
                },
                { name: 'description', label: 'Descripción', type: 'textarea', rows: 4, span: 2 },
                { name: 'sort_order', label: 'Orden', type: 'number', defaultValue: 0 },
                { name: 'active', label: 'Visible', type: 'checkbox', defaultValue: true },
            ]}
        />
    </AdminViewLayout>
);
